import styled from 'styled-components';

import { media } from 'utils/detection';
import Paginator from 'components/Paginator';

export default styled(Paginator)`
  position: relative;
  width: 100%;
  padding: 0 30px;
  margin: 6px 0 0 0;
  box-sizing: border-box;

  ${media.medium`
    margin: 1vw 0 0 0;
  `}
`;
